import React, { type FunctionComponent } from 'react'
import styled from '@emotion/styled'
import { useHideNavbarDueToPendingOnboarding } from '@retailer-platform/domain-onboarding'
import WarehouseProvider from '../../../../utils/contexts/warehouse/WarehouseProvider'
import ErrorBoundary from '../../../../legacy/components/ErrorBoundary'
import { type RetailerScopedRouteParams } from '../../../../legacy/common/types'
import { type DashRouteComponentProps } from '../../../../legacy/dash-components/dash-route/utils/dashRoute.types'
import { RetailerNav } from '../../../../gin-and-tonic/containers/nav/RetailerNav'
import { DASH_NAV_WIDTH, Z_INDEX_FIRST } from '../../../../legacy/common/theme'
import { AppContentContainer } from '../../../../gin-and-tonic/containers/app-content-container/AppContentContainer'
import PartnerProvider from '../../../../utils/contexts/partner/PartnerProvider'
import { useAdminControls } from '../../../../utils/contexts/admin-controls/AdminControlsContext'
import SelectPartner from '../../../../gin-and-tonic/common/select-partner/SelectPartner'
import { ContactHeader } from '../../../utils/ContactHeader'
import { RetailerScopedRoutes } from './RetailerScopedRoutes'

interface Props extends DashRouteComponentProps<RetailerScopedRouteParams> {}

const NavContainer = styled.aside({
  position: 'fixed',
  height: '100%',
  display: 'flex',
  width: DASH_NAV_WIDTH,
  top: 0,
  left: 0,
  zIndex: Z_INDEX_FIRST,
})

export const RetailerScopedSection: FunctionComponent<Props> = ({
  match: {
    params: { partner_id: partnerId, warehouse_id: warehouseId },
  },
  location: { pathname },
}) => {
  const hideNavBar = useHideNavbarDueToPendingOnboarding()
  const { showContactHeader } = useAdminControls()
  const validPartnerId = Number(partnerId) > 0

  if (!validPartnerId) {
    return <SelectPartner autoSelect restrictToPartnerView />
  }

  return (
    <PartnerProvider id={partnerId}>
      {!hideNavBar && (
        <NavContainer>
          <RetailerNav />
        </NavContainer>
      )}
      <WarehouseProvider id={warehouseId}>
        <AppContentContainer>
          {/* Totem does not have a proper staging/dev environment. Totem prod api is not accessible to mesh outside of prod */}
          {showContactHeader && <ContactHeader />}
          <ErrorBoundary pathname={pathname}>
            <RetailerScopedRoutes />
          </ErrorBoundary>
        </AppContentContainer>
      </WarehouseProvider>
    </PartnerProvider>
  )
}
